import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { setCreatedData } from '../../../../ReduxToolkit/Reducers/ProjectSlice';
import { Form, Formik, ErrorMessage, Field } from 'formik';
import { Col, FormGroup, Label, Row } from 'reactstrap'
import { planInitialValue, planValidation } from '../../../../Data/Application/ProjectList/ProjectList';
import ButtonSection from './ButtonSection';
import { PlanInitialValue } from '../../../../Types/Application/ProjectList/ProjectList';
import { TicketPlanName, TicketPlanPrice, TicketSeasonalPrice } from '../../../../utils/Constant';
import Swal from 'sweetalert2';
import api from '../../../../utils/api';

const CreateNewTicketForm = () => {
    const navigate = useNavigate();
    const { createdFormData } = useAppSelector((state) => state.project);
    const dispatch = useAppDispatch();
    const projectSubmit = async (values: PlanInitialValue) => {
      const submittedData = {
        adultPlanId: 0,
        planName: values.title,
        planPrice: values.ticket_price,
        clothPrice: values.clothPrice,
        seasonalPrice: values.seasonal_price,
        seasonalStatus: values.seasonal_status === 'true' ? true : false,
      };
      dispatch(setCreatedData([...createdFormData, submittedData]));
      try {
        const response = await api.post('/api/AdultPlan/AddAdultPlan', submittedData, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          dispatch(setCreatedData([...createdFormData, response.data]));
    
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Ticket plan created successfully.',
          }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/ticket/ticket_plan_list`);
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'Something went wrong while creating the ticket plan.',
        });
      }
    };

    return (
      <Formik initialValues={planInitialValue} validationSchema={planValidation} onSubmit={projectSubmit}>
        {() => (
          <Form className="theme-form">
            <Row>
                <Col sm="4">
                <FormGroup>
                    <Label check>{TicketPlanName}</Label>
                    <Field name="title" type="text" className="form-control" placeholder="Enter Ticket Plan Name..."  />
                    <ErrorMessage name="title" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>{TicketPlanPrice}</Label>
                    <Field name="ticket_price" className="form-control" type="text" placeholder="Enter Ticket Plan Price..."  />
                    <ErrorMessage name="ticket_price" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>{TicketSeasonalPrice}</Label>
                    <Field name="seasonal_price" className="form-control" type="text" placeholder="Enter Ticket Seasonal Price..."  />
                    <ErrorMessage name="seasonal_price" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>Seasonal Status</Label>
                    <Field name="seasonal_status" as="select" className="form-control form-select">
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                    </Field>
                </FormGroup>
                </Col>
            </Row>
            <ButtonSection cancel_url={`/ticket/ticket_plan_list`} />
          </Form>
        )}
      </Formik>
    )
}

export default CreateNewTicketForm